import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Button from "../../ui/Button";
import LoadingSpinner from "../../ui/LoadingSpinner";
import { useTypographyHelpers } from "../../../contexts/DesignContext";

/**
 * Sign Up Form Actions (submit button, messages, sign in link)
 */
const SignUpFormActions = ({
  isLoading,
  otpSent,
  successMessage,
  submitError,
}) => {
  const { t } = useTranslation("auth");
  const { getSupportingText } = useTypographyHelpers();

  return (
    <>
      {/* Success Message */}
      {successMessage && (
        <div className="bg-green-500/10 border border-green-500/20 rounded-2xl p-4">
          <p className="text-green-400 text-sm text-center">{successMessage}</p>
        </div>
      )}

      {/* Submit Error */}
      {submitError && (
        <div className="bg-red-500/10 border border-red-500/20 rounded-2xl p-4">
          <p className="text-red-400 text-sm text-center">{submitError}</p>
        </div>
      )}

      {/* Submit Button */}
      <Button
        type="submit"
        variant="primary"
        color="violet"
        size="lg"
        disabled={!otpSent || isLoading.submitting || !!successMessage}
        className="w-full flex items-center justify-center space-x-3"
      >
        {isLoading.submitting ? (
          <>
            <LoadingSpinner size="sm" />
            <span>{t("signUp.creatingAccount")}</span>
          </>
        ) : (
          t("signUp.signUpButton")
        )}
      </Button>

      {/* Sign In Link */}
      <div className="mt-6 text-center pt-4 border-t border-gray-700/50">
        <p className={`${getSupportingText("small")} text-gray-400 mb-2`}>
          {t("signUp.haveAccount")}
        </p>
        <Link
          to="/signin"
          className="text-violet-400 hover:text-violet-300 transition-colors duration-300 font-medium"
        >
          {t("signUp.signInLink")}
        </Link>
      </div>
    </>
  );
};

export default SignUpFormActions;
